export const environment = {
  production: false,
  urlApiPadrao: 'https://api.dev.xipou.com.br/',
  urlMedia: 'https://media.dev.xipou.com.br/',
  X_TOKEN_API: '262e4801adb5dfe5611a4a83c68365a591f14c48',
  debugMode: 'info',
  s3: "https://s3-dev-icons4u.us-east-1.linodeobjects.com/xipou"
};
